import React from "react";
import PropTypes from "prop-types";

import { Button, ButtonGroup } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faGripHorizontal } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";
import TopMenu from "components/Home/Utils/TopMenu";

class FoldersMenu extends React.PureComponent {
  renderTileToggle() {
    const { isTile, updateIsTile } = this.props;

    return (
      <div className={styles.buttonHolder}>
        <ButtonGroup>
          <Button
            type="secondary"
            style={{ lineHeight: "10px", fontSize: "15px", padding: "10px" }}
            active={isTile}
            onClick={() => updateIsTile(true)}
            title="Tiles"
          >
            <FontAwesomeIcon icon={faGripHorizontal} />
          </Button>
          <Button
            type="secondary"
            style={{ lineHeight: "10px", fontSize: "15px", padding: "10px" }}
            active={!isTile}
            onClick={() => updateIsTile(false)}
            title="Table"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  render() {
    const {
      type,
      typeOptions,
      isLoading,
      updateType,
      hideMenu,
      search,
      hideSearch,
      updateSearch,
      selectedFolder,
      isTableauMode,
      fetchingDatasetCount,
      showSettings,
      updateShowSettings,
      disabledViews
    } = this.props;

    const menuTypeOptions = typeOptions.map((text) => ({ text }));

    if (hideMenu) {
      return <React.Fragment />;
    }
    return (
      <TopMenu
        options={menuTypeOptions}
        selectHandler={updateType}
        selected={type}
        search={hideSearch ? undefined : search}
        searchHandler={hideSearch ? undefined : updateSearch}
        isLoading={isLoading}
        selectedFolder={selectedFolder}
        isTableauMode={isTableauMode}
        fetchingDatasetCount={fetchingDatasetCount}
        updateShowSettings={updateShowSettings}
        showSettings={showSettings}
        disabledViews={disabledViews}
      ></TopMenu>
    );
  }
}

FoldersMenu.defaultProps = {
  hideSearch: false
};

FoldersMenu.propTypes = {
  // Type of view selected
  type: PropTypes.string,
  // Array of possible view types
  typeOptions: PropTypes.arrayOf(PropTypes.string),
  // Function to update the selected view type
  updateType: PropTypes.func,
  // Determines whether search is hidden
  hideSearch: PropTypes.bool,
  // Function to update search
  updateSearch: PropTypes.func,
  // Determines whether the view is in tile mode
  isTile: PropTypes.bool,
  // Function to toggle tile mode
  updateIsTile: PropTypes.func,
  showSettings: PropTypes.bool,
  updateShowSettings: PropTypes.func,
  // Pass an array of disabled view strings if we would like some disabled
  disabledViews: PropTypes.arrayOf(PropTypes.string)
};

export default FoldersMenu;
